import { durationSettingsPath } from "@p0security/shared/configuration/constant";
import { DurationSettings } from "@p0security/shared/configuration/types";
import { useContext } from "react";

import { useFirestoreDoc } from "../../providers/FirestoreProvider";
import { Tenant } from "../Login";

export const useDurationSettings = () => {
  const tenantId = useContext(Tenant);
  return useFirestoreDoc<DurationSettings>(durationSettingsPath(tenantId), {
    live: true,
  });
};
